export const updateModellZaun = ev => {
    return {
        type: 'UPDATEMODELLZAUN',
        ev: ev
    }
}

export const updateMusterZaun = ev => {
    return {
        type: 'UPDATEMUSTERZAUN',
        ev: ev
    }
}

export const updateTabIndexZaun = ev => {
    return {
        type: 'UPDATETABINDEXZAUN',
        ev: ev
    }
}

export const updateModellIndexZaun = ev => {
    return {
        type: 'UPDATEMODELLINDEXZAUN',
        ev: ev
    }
}

export const updateModellTypeIndexZaun = ev => {
    return {
        type: 'UPDATEMODELLTYPEINDEXZAUN',
        ev: ev
    }
}

export const updateStepsZaun = ev => {
    return {
        type: 'UPDATESTEPSZAUN',
        ev: ev
    }
}

export const updateAllVisitedStepsZaun = () => {
    return {
        type: 'UPDATEALLVISITEDSTEPSZAUN'
    }
}

export const updateFormZaun = ev => {
    return {
        type: 'UPDATEFORMZAUN',
        ev: ev
    }
}

export const dimensionKindZaun = ev => {
    return {
        type: 'DIMENSIONKINDZAUN',
        ev: ev
    }
}

export const updateTotalWidthZaun = ev => {
    return {
        type: 'UPDATETOTALWIDTHZAUN',
        ev: ev
    }
}

export const updateSingleTotalDimensionZaun = ev => {
    return {
        type: 'UPDATESINGLETOTALDIMENSIONZAUN',
        ev: ev
    }
}

export const updateHeightZaun = ev => {
    return {
        type: 'UPDATEHEIGHTZAUN',
        ev: ev
    }
}


export const updateSingleDimensionZaun = ev => {
    return {
        type: 'UPDATESINGLEDIMENSIONZAUN',
        ev: ev
    }
}

export const updateSingleFieldDimensionZaun = ev => {
    return {
        type: 'UPDATESINGLEFIELDDIMENSIONZAUN',
        ev: ev
    }
}

export const deleteSingleFiledZaun = ev => {
    return {
        type: 'DELETESINGLEFIELDZAUN',
        ev: ev
    }
}

export const addSingleTextFieldZaun = () => {
    return {
        type: 'ADDSINGLETEXTFIELDZAUN'
    }
}

export const selectWishColorZaun = ev => {
    return {
        type: 'SELECTWISHCOLORZAUN',
        ev: ev
    }
}

export const selectKindOfColorZaun = ev => {
    return {
        type: 'SELECTKINDOFCOLORZAUN',
        ev: ev
    }
}

export const selectColorZaun = ev => {
    return {
        type: 'SELECTCOLORZAUN',
        ev: ev
    }
}

export const updateZaunspitzen = ev => {
    return {
        type: 'UPDATEZAUNSPITZEN',
        ev: ev
    }
}

export const updatePfostenZaun = ev => {
    return {
        type: 'UPDATEPFOSTENZAUN',
        ev: ev
    }
}

export const updateKappenZaun = ev => {
    return {
        type: 'UPDATEKAPPENZAUN',
        ev: ev
    }
}

export const updateProductToMerklisteZaun = () => {
    return {
        type: 'UPDATEPRODUCTTOMERKLISTEZAUN'
    }
}

export const updateDescriptionZaun = ev => {
    return {
        type: 'UPDATEDESCRIPTIONZAUN',
        ev: ev
    }
}

export const selectUploadDataZaun = ev => {
    return {
        type: 'SELECTUPLOADDATAZAUN',
        ev: ev
    }
}

export const updateEditZaun = () => {
    return {
        type: 'UPDATEEDITZAUN'
    }
}



